import { IconChevronDown, IconClock } from "@tabler/icons-react";
import { Stack, Typography } from "@altimateai/lego";
import { cn } from "@/lib/utils";
import styles from "./styles.module.scss";
import { TriggerProps } from "./InlineTrigger";

const DefaultTrigger = ({
  id,
  isOpen,
  wrapperClass,
  showTimezone,
  label,
  staticRangeLabel,
  renderDateRange,
}: TriggerProps) => {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  return (
    <Stack
      id={id}
      className={cn(styles.datePickerWrapper, wrapperClass)}
      aria-label="Date range picker"
      aria-expanded={isOpen}
    >
      {showTimezone && <div className={styles.timezone}>Timezone: {timezone}</div>}
      {staticRangeLabel ? renderDateRange() : null}
      <div className={cn("al-min-h-9", styles.datePicker)}>
        {label ? (
          <Typography variant="body" size="xs">
            {label}
          </Typography>
        ) : (
          <IconClock className={"al-text-muted-foreground al-size-5 al-mr-1"} />
        )}
        <div className={styles.time} aria-label="Selected date range">
          {staticRangeLabel || renderDateRange() || "All time"}
        </div>
        <IconChevronDown className={"al-size-4"} />
      </div>
    </Stack>
  );
};

export default DefaultTrigger;
